import React from 'react'
import { useSelector } from 'react-redux'
import { ReactPortal } from 'gu-ui-kit'
import Notification from 'modules/Notifications/submodules/Notification'
import styles from 'modules/Notifications/notifications.module.scss'

const Notifications = () => {
  // const dispatch = useDispatch()

  // // этот код отображает flash message, которые может передать бэкенд при первой загрузке документа. единожды!
  // useEffect(() => window.flashes?.forEach((flash) => dispatch(notificationShow({ ...flash }))), [])

  const { notifications } = useSelector(({ notifications }) => notifications)

  return (
    <ReactPortal wrapperId={'notification-portal'}>
      {notifications.length > 0 ? (
        <div className={styles['notifications']}>
          {notifications.map((notification) => (
            <Notification
              key={'notification-component-' + notification.UUID}
              {...notification}
            />
          ))}
        </div>
      ) : null}
    </ReactPortal>
  )
}

export default Notifications
